module.exports = __webpack_public_path__ + "h5/img/vip1.4a328cae.png";